import { useEffect } from 'react'
import type { QuestionProps } from '../eform.types'

/**
 * A date as FTP's page writes a read-only date (type 24): PHP's
 * date('l, F jS, Y'), e.g. "Tuesday, October 13th, 2026". FTP's staff screens
 * show the stored text as it is (R40).
 */
export function ftpLongDate(date: Date): string {
  const day = date.getDate()
  const teen = day % 100 >= 11 && day % 100 <= 13
  const suffix = teen ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[day % 10] ?? 'th'
  const weekday = date.toLocaleDateString('en-US', { weekday: 'long' })
  const month = date.toLocaleDateString('en-US', { month: 'long' })
  return `${weekday}, ${month} ${day}${suffix}, ${date.getFullYear()}`
}

export default function ReadOnlyDate({  value, onChange }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '' : value

  useEffect(() => {
    if (!strValue) {
      onChange(ftpLongDate(new Date()))
    }
  }, [strValue, onChange])

  return (
    <input
      type="text"
      value={strValue}
      readOnly
      className="w-full rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600 cursor-not-allowed"
    />
  )
}
